<template>
    <div>
        <!--
        <div class="maintenance" v-if="this.$route.name == 'maintenance'">
            <router-view/>
        </div>
        <div v-else>
        -->
        <Header />
            <main>
                <router-view/>
            </main>

            <!-- notification modal -->
            <!--<ModalNotification ref="notification"/>-->
        <!--    
        </div>
        -->

        <Footer />
    </div>
</template>

<script>
  export default {
    name: 'app',
    metaInfo: {
      title: 'Travel booking - Soluzioni online per il marketing',
      titleTemplate: '%s | ' + process.env.VUE_APP_SITE_TITLE,
      meta: [
        { vmid: 'metaDescription', name: 'Description', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
        { vmid: 'metaAbstract', name: 'abstract', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
        { vmid: 'metaClassification', name: 'Classification', content: 'Commercial' },
        { vmid: 'metaResourceType', name: 'resource-type', content: 'document' },
        { vmid: 'metaDistribution', name: 'Distribution', content: 'Global' },
        { vmid: 'metaRating', name: 'Rating', content: 'General' },
        { vmid: 'metaLanguage', name: 'Language', content: 'IT' },
        { vmid: 'metaOwner', name: 'Owner', content: 'Salabam SRL' },
        { vmid: 'ogTitle', property: 'og:title', content: 'Travel booking - Soluzioni online per il marketing' },
        { vmid: 'ogSiteName', name: 'site_name', content: 'Vivamod | modern travel' },
        { vmid: 'ogType', name: 'og:type', content: 'website' },
        { vmid: 'ogUrl', name: 'og:url', content: window.location.href },
        { vmid: 'ogImage', name: 'og:image', content: process.env.VUE_APP_SITE_HOST + 'img/home/bg.jpg' },
        { vmid: 'ogImageWidth', name: 'og:image:width', content: '625' },
        { vmid: 'ogImageHeight', name: 'og:image:height', content: '600' },
        { vmid: 'ogDescription', name: 'og:description', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
        { vmid: 'dcTitle', name: 'DC.title', lang: 'it', content: 'Travel booking - Soluzioni online per il marketing' },
        { vmid: 'dcCreator', name: 'DC.creator', content: 'Salabam SRL' },
        { vmid: 'dcSubject', name: 'DC.subject', lang: 'it', content: 'salabam;viaggi online;online travel booking;online travel agency;agenzia viaggi online;prenotazione online viaggi;viaggi welfare aziendale;viaggi welfare;viaggi promozioni;viaggi marketing;viaggi viaggi programmi fedeltà;viaggi programma fedeltà;viaggi loyalty program;catalogo a premi viaggi' },
        { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Soluzioni online integrate, brandizzate, capaci di comunicare i valori e i messaggi della tua azienda. Disponibilità di viaggio in tempo reale.' },
        { vmid: 'dcType', name: 'DC.type', scheme: 'DCTERMS.DCMIType', content: 'Text' },
        { vmid: 'dcFormat', name: 'DC.format', content: 'text/html' },
        { vmid: 'dcIdentifier', name: 'DC.identifier', scheme: 'DCTERMS.URI', content: process.env.VUE_APP_SITE_HOST },
        { vmid: 'dcLanguage', name: 'DC.language', scheme: 'DCTERMS.RFC1766', content: 'IT' },
        { vmid: 'robots', name: 'robots', content: process.env.VUE_APP_META_ROBOTS },
      ]
    },
    components: {
        Header: () => import(('./components/blocks/header/header'))
            .then(function(Header) {
                window.console.log('async: Header Component loaded')
                return Header
            }),                
        Footer: () => import(('./components/blocks/footer/footer'))
            .then(function(Footer) {
                window.console.log('async: Footer Component loaded')
                return Footer
            }),                
    },
    beforeMount() {
    },
    watch: {
    },
    mounted()
    {
        /*
        let _this = this
        window.eventBus.$on('gotNotification', function(data) { 
            _this.$refs.notification.handleNotification(data)
        })
        */
    },
    created () {
    },
    destroyed () {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
    @import 'scss/_bootstrap.scss';
    @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700&display=swap');
    @import 'scss/_app.scss';
</style>